import { useAccounts } from '@paradigm/features/src/unified-rfqs/contexts/accounts';

/**
 *
 * @returns flag if any of the api-credentials under this user has the
 * has_position_readable_permission enabled to show the Positions management view
 */
export function usePositionsManagementAccountPermissionEnabled(): boolean {
  const { accounts } = useAccounts();
  return accounts.some((acc) => acc.has_position_readable_permission);
}
